import React from "react";
import Card from "./card";
import {ReactComponent as Web} from "../../assets/cardImages/web.svg";
import {ReactComponent as PC} from "../../assets/cardImages/pc.svg";
import {ReactComponent as Settings} from "../../assets/cardImages/settings.svg";
import {ReactComponent as Chart} from "../../assets/cardImages/chart.svg";
import Title from "../title";
import styled from "styled-components";



const CardsWrapper = styled.div`
  
  width: 100%;
  display: grid;
  gap: 50px;
  grid-template-columns: repeat(auto-fill, minmax(400px,1fr));


`;


const CardSection = () => {

  const data = [
    {
      image: <Web/>,
      text: 'Create Ai Based Website',
    },
    {
      image: <Web/>,
      text: 'Write SEO Friendly Contents'
    },
    {
      image: <Settings/>,
      text: 'Maintain site with Artificial Intelligence'
    }, {
      image: <Chart/>,
      text: 'Response customer with data analyzing data'
    },
    {
      image: <PC/>,
      text: 'Show custom interface with Ai'
    }
  ];


  return (
    <>
      <Title h1='Explore the features!' isButtonShow={false}>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Maecenas purus odio tempor rutrum...</Title>
      <CardsWrapper>
        {data.map(({image, text}) => <Card key={text} image={image} text={text}/>)}
      </CardsWrapper>
    </>
  )
}

export default CardSection;
